import { useContext, useMemo } from 'react';
import { UserContext } from 'src/context';
import { GetAllUserByCompany, GetCompanyTeams } from 'src/graphql/company';
import { buildMentionUsers } from 'src/utils/mentions';

/**
 * Lista unificada para @-menciones: usuarios de la empresa + miembros de equipos
 * (misma fuente que comentarios en conciliación). Incluye siempre al usuario actual.
 */
export function useCompanyMentionUsers(companyId, currentUserId) {
  const userInfo = useContext(UserContext);
  const { data: usersData } = GetAllUserByCompany({ companyId });
  const { data: teamsData } = GetCompanyTeams({ companyId });

  const allUsersByCompany = usersData?.allUsersByCompany || [];
  const companyTeams = teamsData?.getCompanyTeams || [];

  const currentUser = useMemo(() => {
    const email = userInfo?.email;
    if (!email) return null;
    return {
      id: currentUserId || userInfo?.id || userInfo?._id,
      email,
    };
  }, [currentUserId, userInfo?.email, userInfo?.id, userInfo?._id]);

  const mentionUsers = useMemo(
    () => buildMentionUsers({ users: allUsersByCompany, teams: companyTeams, currentUser }),
    [allUsersByCompany, companyTeams, currentUser],
  );

  return mentionUsers;
}
